import * as React from 'react';

import * as styles from './styles.css';

import imgSrc from '../Layout/DesktopLayout/assets/img.svg';
import { UIHeading2, UIText1, IconChevronLeft16, UIHeading4, IconArrowLeft16 } from '@cian/ui-kit';

interface IHeroBannerProps extends React.PropsWithChildren {
  isDesktop: boolean;
  onBackClick: () => void;
}

export const HeroBanner: React.FC<IHeroBannerProps> = ({ isDesktop, onBackClick, children }) => {
  return (
    <>
      {!isDesktop && (
        <div className={styles['mobile-header']}>
          <a className={styles['back-button']} onClick={onBackClick}>
            <IconArrowLeft16 color="primary_100" />

            <UIHeading4 color="primary_100">Вернуться в Мой дом</UIHeading4>
          </a>
        </div>
      )}

      <div className={styles['container']}>
        <div className={styles['wrapper']}>
          <div>
            {isDesktop && (
              <a className={styles['back-button']} onClick={onBackClick}>
                <IconChevronLeft16 color="primary_100" />

                <UIHeading4 color="primary_100">Вернуться в Мой дом</UIHeading4>
              </a>
            )}
            <div className={styles['title']}>
              {isDesktop ? <h1>Как заработать на квартире</h1> : <UIHeading2>Как заработать на квартире</UIHeading2>}
              <UIText1>
                Ваша недвижимость должна приносить деньги. Расскажем про несколько сценариев получения дохода
              </UIText1>
            </div>

            <div>{children}</div>
          </div>

          <div className={styles['bg-image']}>
            <img src={imgSrc} />
          </div>
        </div>
      </div>
    </>
  );
};
